import { supabase } from './supabase'

/**
 * The current session's access token, for calling this app's own endpoints.
 *
 * They hold the one credential the page must never see: the key that pays for
 * reading a policy document. Fewer than the business app has, because a
 * household connects no payroll and no store, and the endpoints that held those
 * tokens do not exist here. What the remaining ones need back is proof of who
 * is asking, which is what this is.
 *
 * Null where nobody is signed in, and the endpoint answers accordingly rather
 * than this deciding on its behalf.
 */
export async function sessionToken(): Promise<string | null> {
  const { data } = (await supabase?.auth.getSession()) ?? { data: { session: null } }
  return data.session?.access_token ?? null
}
